export const FAILED_DEPART_ITEMS_BASE_PATH = "/transfers/failed-depart-items";
